import {inject, injectable} from 'inversify';

import type {CoreUserCardsListParams} from '../../../../../api/types/core/methods';
import type {FetchCardsListQuery} from '../FetchCardsList.query';

import {apiRequest} from '../../../../../api/utils/apiRequest';
import {expandObj} from '../../../../../api/utils/expand';
import {CardMapperJrpc} from '../../../../domain/Card/mappers/Card.mapper.jrpc';

@injectable()
export class FetchCardsListQueryJrpc implements FetchCardsListQuery {
  constructor(
    @inject(CardMapperJrpc) private readonly cardMapper: CardMapperJrpc,
  ) {}

  async exec(): Promise<FetchCardsListQuery.Response> {
    const expand = this.cardMapper.expand.getByEnv();
    const response = await apiRequest<CoreUserCardsListParams>({
      method: 'user.cards.list',
      params: {
        expand,
        query: [['type', '==', 'card']],
        sort: [['created', -1]],
      },
    });
    const expanded = response._items.map(item =>
      expandObj(item, {
        expand,
        expanded: response._expanded,
      }),
    );

    return expanded.map(item => this.cardMapper.mapDataToModel(item));
  }
}
